import { render, staticRenderFns } from "./search_page.vue?vue&type=template&id=63ca63fe&scoped=true"
import script from "./search_page.vue?vue&type=script&lang=js"
export * from "./search_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca63fe",
  null
  
)

export default component.exports